import Index500StockFund from './index500StockFund';

export default Index500StockFund;
